export class FetchPharmAddress {
  static readonly type = '[PharmAddress] Fetch Pharm Address';
  constructor(public pharmacy: string, public patientId: number, public customerAddressId: string) {}
}
